<template>
  <div class="pc-form">
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <!-- Hidden name/email fields (kept for form compatibility) -->
      <b-row style="display: none;">
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group
              label="Name"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="engineerStatusForm.name"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Name"
                readonly
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="Email"
            rules="required"
          >
            <b-form-group
              label="Email"
              label-for="email"
            >
              <b-form-input
                id="email"
                v-model="engineerStatusForm.email"
                type="email"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Email"
                readonly
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row>
        <!-- ── Permissions ────────────────────────────── -->
        <b-col md="6">
          <div class="pc-section-card pc-section-card--green">
            <div class="pc-section-card__header">
              <feather-icon
                icon="KeyIcon"
                size="15"
                class="mr-50"
              />
              Permissions
              <span class="pc-section-card__count ml-auto">
                {{ (engineerStatusForm.status_id || []).length }} selected
              </span>
            </div>
            <div class="pc-section-card__body">
              <b-form-checkbox
                v-for="opt in optionsStatus"
                :key="opt.value"
                v-model="engineerStatusForm.status_id"
                :value="opt.value"
                class="pc-chip pc-chip--green"
              >
                {{ opt.text }}
              </b-form-checkbox>
            </div>
          </div>
        </b-col>

        <!-- ── Allocation Sources ─────────────────────── -->
        <b-col md="6">
          <div class="pc-section-card pc-section-card--teal">
            <div class="pc-section-card__header">
              <feather-icon
                icon="GlobeIcon"
                size="15"
                class="mr-50"
              />
              Allocation Sources
              <span class="pc-section-card__count ml-auto">
                {{ (engineerStatusForm.allocation_sources || []).length }} selected
              </span>
            </div>
            <div class="pc-section-card__body">
              <b-form-checkbox
                v-for="opt in optionsAllocationSources"
                :key="opt.value"
                v-model="engineerStatusForm.allocation_sources"
                :value="opt.value"
                class="pc-chip pc-chip--teal"
              >
                {{ opt.text }}
              </b-form-checkbox>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Errors -->
      <b-row v-if="Object.values(errors).length > 0">
        <b-col cols="12">
          <p
            v-for="(error, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error }}
          </p>
        </b-col>
      </b-row>

      <!-- Save Button -->
      <b-row class="mt-1">
        <b-col cols="12">
          <b-button
            v-if="!loaderStatus"
            variant="success"
            class="pc-save-btn"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addUserStatusSite"
          >
            <feather-icon
              icon="SaveIcon"
              size="16"
              class="mr-50"
            />
            Save Changes
          </b-button>
          <b-button
            v-else
            variant="success"
            disabled
            class="pc-save-btn"
          >
            <b-spinner
              small
              type="grow"
              class="mr-50"
            />
            Saving...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>

<script>
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  props: {
    engineerStatusForm: {
      type: Object,
      default: () => ({}),
    },
    optionsAllocationSources: {
      type: Array,
      default: () => [],
    },
    optionsStatus: {
      type: Array,
      default: () => [],
    },
    fetchDataCertificates: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      errors: {},
      optionsStatusId: [],
      allCertificates: [],
      loaderStatus: false,
      id: this.$store.state.generalIds.id,
      AllDataCerStatus: {},
    }
  },
  setup() {
    const { getValidationState } = formValidation()

    return {
      getValidationState,
    }
  },

  methods: {
    addUserStatusSite() {
      if (this.$route.params.id) {
        this.loaderStatus = true
        const formData = new FormData()
        formData.append('_method', 'PUT')

        Object.keys(this.engineerStatusForm).forEach(key => {
          let value = this.engineerStatusForm[key]
          if (Array.isArray(value)) {
            value = value.filter(item => item !== null)
          }
          if (key === 'status_id' || key === 'allocation_sources') {
            if (value === null || (Array.isArray(value) && value.length === 0)) {
              formData.append(`${key}[]`, '')
            } else if (Array.isArray(value)) {
              value.forEach(item => {
                formData.append(`${key}[]`, item)
              })
            }
          } else {
            formData.append(key, value)
          }
        })

        axios
          .post(`/engineer/${this.$route.params.id}`, formData)
          .then(res => {
            if (res.status === 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Updated Successfully',
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              this.fetchDataCertificates()
            }
          })
          .catch(error => {
            if (error.response.status) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${error.response.data.message}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loaderStatus = false
          })
      }
    },
  },
}
</script>

<style lang="scss">
@import './certificates-wizard.scss';
</style>
